<section class="rfq pb-4">
    <div class="rfq__content">
        <section>
            <div class="card">
                <div class="card-head p-4">
                    <div class="d-flex justify-content-between">
                        <h6 class="mb-0 align-self-center">
                            <strong>Negotiation Status</strong> : In-progress - Buyer has requested for offer price
                        </h6>
                        <div>
                            <a class="btn btn-outline-primary mx-2" [routerLink]="ROUTES.SUPPLIER.HOME">
                                Cancel
                            </a>
                            <button class="btn btn-primary mx-2 text-white"
                                (click)="sendConsolidatedNegotiationDetails()">
                                <span>Send Consolidated Offers</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive table-wrapper">
                        <form [formGroup]="negotiationForm">
                            <table class="table table-striped mb-0 table-hover">
                                <thead class="table-active">
                                    <tr>
                                        <th scope="col">Line Item#</th>

                                        <th scope="col">Material Code</th>
                                        <th scope="col">Item Category</th>
                                        <th scope="col">Item Description</th>
                                        <th scope="col">Specs/Short Description</th>

                                        <th scope="col">Buyer's Counter Offer</th>
                                        <th scope="col">Buyer's remarks</th>
                                        <th scope="col">Final Price*</th>
                                        <th scope="col">Original Price</th>
                                        <th scope="col">packing Val. Type</th>
                                        <th scope="col">Packing charge</th>
                                        <th scope="col">Final Packing charge</th>
                                        <th scope="col">Freight Val. Type</th>
                                        <th scope="col">Freight charge</th>
                                        <th scope="col">Final Freight charge</th>
                                        <th scope="col">Original payment terms</th>
                                        <th scope="col">Final payment terms</th>
                                        <th scope="col">Supplier Remarks</th>
                                        <th scope="col">Offer Acceptance Status</th>
                                        <th scope="col">Negotiation Status</th>
                                        <!-- <th scope="col">Action</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="rfqTemplate">
                                        <ng-container *ngFor="let rfq_supplier_quotations of rfqTemplate;let i = index">
                                            <ng-container [formArrayName]="'negotiations'">
                                                <tr [formGroupName]="i">
                                                    <th scope="row">
                                                        {{rfq_supplier_quotations.line_item_number}}
                                                    </th>
                                                    <td>
                                                        {{rfq_supplier_quotations?.line_item_id.material_code}}
                                                    </td>
                                                    <td>
                                                        {{rfq_supplier_quotations?.line_item_id.item_category}}
                                                    </td>
                                                    <td>
                                                        {{rfq_supplier_quotations?.line_item_id.item_desc}}
                                                    </td>
                                                    <td>
                                                        {{rfq_supplier_quotations?.line_item_id.short_text}}
                                                    </td>

                                                    <td>

                                                        <span
                                                            *ngIf="rfq_supplier_quotations.buyer_counter_offer; else showEmpty">
                                                            {{rfq_supplier_quotations.line_item_id.currency}}
                                                            {{rfq_supplier_quotations.buyer_counter_offer}}
                                                        </span>
                                                    </td>
                                                    <td> {{rfq_supplier_quotations.buyer_remarks || "-"}} </td>
                                                    <td>
                                                        <div class="my-1">
                                                            <input type="text" id="final_price" class="form-control"
                                                                placeholder="Final Price" formControlName="final_price"
                                                                style="min-width: 100px;">
                                                        </div>
                                                    </td>
                                                    <td> {{rfq_supplier_quotations.original_price}} </td>
                                                    <td> {{rfq_supplier_quotations.packing_percent_or_amount}} </td>
                                                    <td> {{rfq_supplier_quotations.packing_charge}} </td>
                                                    <td>
                                                        <div class="my-1">
                                                            <input type="text" id="final_packing_charge"
                                                                class="form-control" placeholder="Final Packing charge"
                                                                formControlName="final_packing_charge"
                                                                style="min-width: 100px;">
                                                        </div>
                                                    </td>
                                                    <td> {{rfq_supplier_quotations.freight_percent_or_amount}} </td>
                                                    <td> {{rfq_supplier_quotations.freight_charge}} </td>
                                                    <td>
                                                        <div class="my-1">
                                                            <input type="text" id="final_freight_charge"
                                                                class="form-control" placeholder="Final Freight charge"
                                                                formControlName="final_freight_charge"
                                                                style="min-width: 100px;">
                                                        </div>
                                                    </td>

                                                    <td> {{rfq_supplier_quotations.original_payment_terms}} </td>
                                                    <td>
                                                        <div class="my-1">
                                                            <select type="number" id="final_payment_terms"
                                                                class="form-control w-auto"
                                                                placeholder="Final Payment Terms"
                                                                formControlName="final_payment_terms">
                                                                <ng-container
                                                                    *ngFor="let paymentTerm of paymentTermsList;">
                                                                    <option [value]="paymentTerm.code">
                                                                        {{paymentTerm.code}} -
                                                                        {{paymentTerm.description}}</option>
                                                                </ng-container>
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="my-1">
                                                            <input type="text" id="supplier_remarks"
                                                                class="form-control" placeholder="Supplier Remarks"
                                                                formControlName="supplier_remarks"
                                                                style="min-width: 100px;">
                                                        </div>
                                                    </td>
                                                    <td> {{rfq_supplier_quotations.status}} </td>
                                                    <td> {{rfq_supplier_quotations.negotiation_status}} </td>
                                                </tr>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</section>

<ng-template #showEmpty>
    <span>-</span>
</ng-template>